import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import { getTable } from "../../../../Services/tooltipService";
import _ from "lodash";
import { Accordion, AccordionTab } from "primereact/accordion";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import TextareaElement from "../../../../Components/UiComponents/TextareaElement";
import {
  getCompetitors,
  getCustomer,
  updateCompetitor,
} from "../../../../Services/customerServices";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import RadioElement from "../../../../Components/UiComponents/RadioElement";
import AutoCompleteElement from "../../../../Components/UiComponents/AutoCompleteElement";
import { api } from "../../../../Apis/interceptor";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import DataTable from "../../../../Components/UiComponents/DataTable";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import { Dialog } from "primereact/dialog";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import { Tooltip } from "primereact/tooltip";
import { useForm, Controller } from "react-hook-form";
import MultiSelectElement from "../../../../Components/UiComponents/MultiSelectElement";
import { useOpportunity } from "../../../../Providers/OpportunityContext";
import Loader from "../../../../Components/UiComponents/Loader";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";

const PurposeScore = ((props) => {
  const {
    formState: { errors },
    setValue,
    control,
  } = useForm();

  const [radio, setRadio] = useState("");
  const [frameworkData, setFrameworkData] = useState([]);
  const [selectedFramework, setSelectedFramework] = useState(null);
  const handleInputChange = (value) => {
    setRadio(value);
  };
  const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
  const [regions, setRegions] = useState([]);
  const [regionsText, setRegionsText] = useState("");
  const [valueChainText, setValueChainText] = useState("");
  const [noResults3, setNoResults3] = useState(false);
  const [projectAddressText, setProjectAddressText] = useState("");
  const [projectCoordinates, setProjectCoordinates] = useState("");
  const toastRef = useRef();
  const [opportunityData, setOpportunityData] = useState({});
  const [editData, setEditData] = useState();
  const [competitorList, setCompetitorList] = useState(
    props.opportunityData.additional?.competitor_list || []
  );
  const [oppSelectivityHeaders, setOppSelectivityHeaders] = useState([]);
  const [oppSelectivityTableHeading, setOppSelectivityTableHeading] = useState(
    []
  );
  const [oppSelectivityTableStatus, setOppSelectivityTableStatus] =
    useState(null);
  const [allCompetitorsList, setAllCompetitorsList] = useState([]);
  const [filteredCompetitors, setFilteredCompetitors] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [addRowsPopup, setAddRowsPopup] = useState(false);
  const [valueChain, setValueChain] = useState("");
  const [valueChainName, setValueChainName] = useState("");
  const [customerTooltipData, setCustomerTooltipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showVideo, setShowVideo] = useState(false);


  const lowestScoringColumns = [
    {
      field: "factor_text",
      header: "Lowest Scoring Factors",
      style: { width: "30%" },
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const highestScoringColumns = [
    {
      field: "factor_text",
      header: "Highest Scoring Factors",
      style: { width: "30%" },
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const recomendendColumns = [
    {
      field: "factor_text",
      header: "Recommended Priorities for Improving Fit with Purpose",
      style: { width: "30%" },
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  useEffect(() => {
    getCustomerData();
  }, [props.customerId]);

  useEffect(() => {
    if (props.opportunityData) {
      setOpportunityData(props.opportunityData);
    }
  }, [props.opportunityData]);

  useEffect(() => {
		if (!_.isEmpty(opportunityData) && props.connectionsToProfessionalTeam) {
			getEditData(opportunityData)
		}
	}, [opportunityData, props.connectionsToProfessionalTeam, globalOpportunityData?.opportunity?.tender_period_opportunity])

  useEffect(() => {
    setProjectCoordinates(
      props.opportunityData?.additional?.project_coordinates
    );
  }, [props?.opportunityData?.additional?.project_coordinates]);

  useEffect(() => {
    setProjectAddressText(props.opportunityData.additional?.project_location);
  }, [props.opportunityData.additional?.project_location]);
 
  useEffect(() => {
    
    const initializeAutocomplete = () => {
      const inputElement = document.querySelector('.project-address'); // Using class selector
      if (window.google && inputElement) {
        const autocomplete = new window.google.maps.places.Autocomplete(inputElement);
  
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          if (!place.geometry) {
            console.log("No details available for input: '" + place.name + "'");
            return;
          }
  
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          const coordinates = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
          const address = place.formatted_address;
  
          setProjectCoordinates(coordinates);
          setProjectAddressText(address);
  
          // Update global state with the address and coordinates
          setGlobalOpportunityData((prevData) => ({
            ...prevData,
            additional: {
              ...prevData.additional,
              project_location: address,
              project_coordinates:coordinates,
            },
          }));
        });
      } else {
        console.error('Google Maps or input field not available');
      }
    };
    
    initializeAutocomplete()
    
  }, [projectAddressText]);


  useEffect(() => {
    getRegions();
  }, [props.regions]);

  useEffect(() => {
    setRadio(props.opportunityData.opportunity?.existing_framework);
  }, [props.opportunityData.opportunity?.existing_framework]);

  useEffect(() => {
    getTableFun();
  }, [props.customerId]);

  useEffect(() => {
    getCompetitorsList();
  }, [props.branch]);

  useEffect(() => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      additional: {
        ...prevData.additional,
        competitor_list: competitorList
      },
    }));
    
  }, [competitorList]);

  useEffect(() => {
    props.computeScore(0, "ProjectDuration", props.projectDuration.find(
      (obj) =>
        obj.label ===
      globalOpportunityData?.opportunity?.project_duration
    ), props.projectDuration.find(
      (obj) =>
        obj.label ===
      props.opportunityData?.opportunity?.project_duration
    ));
  }, [globalOpportunityData?.opportunity?.project_duration])

  useEffect(() => {
    props.computeScore(0, "TenderPeriod", props.tenderPeriod.filter(
      (item) =>
        item.label === globalOpportunityData?.opportunity?.tender_period_opportunity
    )[0], props.tenderPeriod.filter(
      (item) =>
        item.label === props.opportunityData?.opportunity?.tender_period_opportunity
    )[0]);
  }, [globalOpportunityData?.opportunity?.tender_period_opportunity])

  const getRegions = (event) => {
    const val = event?.query;
    let filtered = [];

    if (_.isEmpty(val)) {
      filtered = props.regions.slice(0, 8);
    } else {
      const lowerCaseVal = val.toLowerCase();
      filtered = props.regions.filter((item) =>
        item.label.toLowerCase().includes(lowerCaseVal)
      );
    }

    setNoResults3(filtered.length === 0);
    setRegions(filtered);
  };

  const handleGetFramework = async () => {
    const framworkResponse = await api.get("/api/v1/getFrameworks", {
      params: { cust_id: props.customerId, searchVal: selectedFramework },
    });
    const frameworkDisplayNames = framworkResponse.data.framework.map(
      (framework) => framework.framework_display_name
    );
    setFrameworkData(frameworkDisplayNames);
  };

  const getTableFun = async () => {
    try {
        setLoading(true); 

        const getTableResponse = await getTable(props.customerId);

        // Ensure the response contains the expected structure
        if (getTableResponse.data && getTableResponse.data.cust.length > 0) {
            const oppFieldsTable = _.find(getTableResponse.data.cust[0]?.modules, {
                module_name: "Pipeline",
            });

            if (oppFieldsTable) {
                const oppSelectivityTable = _.find(oppFieldsTable.sub_modules, {
                    sub_module_name: "Selectivity",
                })?.tables;

                if (oppSelectivityTable) {
                    const competitorListTable = _.find(oppSelectivityTable, {
                        table_name: "Competitor's List",
                    });

                    if (competitorListTable) {
                        const oppSelectivityHeaders = competitorListTable.headers;
                        const oppSelectivityTableHeading = competitorListTable.display_name;
                        const oppSelectivityTableStatus = competitorListTable.status;

                        setOppSelectivityTableHeading(oppSelectivityTableHeading);
                        setOppSelectivityTableStatus(oppSelectivityTableStatus);
                        setOppSelectivityHeaders(oppSelectivityHeaders);
                    } else {
                        toastRef.current.showToast({
                            type: 'info',
                            message: "Competitor's List table not found."
                        });
                    }
                } else {
                    toastRef.current.showToast({
                        type: 'info',
                        message: "Selectivity sub-module tables not found."
                    });
                }
            } else {
                toastRef.current.showToast({
                    type: 'info',
                    message: "Pipeline module not found."
                });
            }
        } else {
            toastRef.current.showToast({
                type: 'info',
                message: "No customer data found."
            });
        }
    } catch (error) {
        console.error("Error fetching table data:", error);
        toastRef.current.showToast({
            type: 'error',
            message: 'An error occurred while fetching table data. Please try again or contact Admin.'
        });
    } finally {
        setLoading(false); 
    }
};


  const getEditData = (opportunityDetails) => {
    if (opportunityDetails) {
      const edit = _.cloneDeep(opportunityDetails);

      edit.business_unit = props?.businessUnit?.filter(
        (item) => item.label === opportunityDetails?.business_unit
      )[0];

      if (edit.opportunity && edit.summary && edit.additional) {
        // edit.opportunity.client_meetings = props.clientMeetings.filter(
        //   (item) =>
        //     item.label === opportunityDetails?.opportunity.client_meetings
        // )[0];

        // edit.opportunity.connections_professional_team =
        //   props.connectionsToProfessionalTeam.filter(
        //     (item) =>
        //       item.label ===
        //       opportunityDetails?.opportunity.connections_professional_team
        //   )[0];

        edit.services = props.opportunityType.filter(
          (item) => item.label === opportunityDetails?.services
        )[0];

        // edit.summary.work_type = props.workType.filter(
        //   (item) => item.label === opportunityDetails?.summary.work_type
        // )[0];

        edit.opportunity.framework_length = props.frameworkLength.filter(
          (item) =>
            item.label === opportunityDetails?.opportunity.framework_length
        )[0];

        // edit.opportunity.project_type = props.projectType.filter(
        //   (item) => item.label === opportunityDetails?.opportunity.project_type
        // )[0];

        // edit.opportunity.source_opportunity = props.sourceOfOpportunity.filter(
        //   (item) =>
        //     item.label === opportunityDetails?.opportunity.source_opportunity
        // )[0];

        edit.opportunity.work_classification =
          props.workClassificationV2.filter(
            (item) =>
              item.label === opportunityDetails?.opportunity.work_classification
          )[0];

        // edit.summary.form_of_contract = props.formOfContract1.filter(
        //   (item) => item.label === opportunityDetails?.summary.form_of_contract
        // )[0];

        // edit.summary.procurement_route = props.procurementRoute.filter(
        //   (item) => item.label === opportunityDetails?.summary.procurement_route
        // )[0];

        edit.sector = props.sector.filter(
          (item) => item.label === opportunityDetails?.sector
        )[0];

        edit.opportunity.project_value = props.projectValue.filter(
          (item) => item.label === opportunityDetails?.opportunity.project_value
        )[0];

        edit.opportunity.project_margin = props.projectMargin.filter(
          (item) =>
            item.label === opportunityDetails?.opportunity.project_margin
        )[0];

        // edit.opportunity.risks = props.risks.filter(
        //   (item) => item.label === opportunityDetails?.opportunity.risks
        // )[0];

        edit.opportunity.bim_requirement = props.bimRequirement.filter(
          (item) =>
            item.label === opportunityDetails?.opportunity.bim_requirement
        )[0];

        //Additional
        edit.additional.fit_with_business_plan =
          props.fitWithBusinessPlan.filter(
            (item) =>
              item.label ===
              opportunityDetails?.additional.fit_with_business_plan
          )[0];

        edit.additional.profile = props.profile.filter(
          (item) => item.label === opportunityDetails?.additional.profile
        )[0];

        edit.additional.payment_terms = props.paymentTermsDays.filter(
          (item) => item.label === opportunityDetails?.additional.payment_terms
        )[0];

        edit.additional.winnability = props.winnability.filter(
          (item) => item.label === opportunityDetails?.additional.winnability
        )[0];

        edit.additional.selection_weighing_factors =
          props.selectionWeightingFactors.filter(
            (item) =>
              item.label ===
              opportunityDetails?.additional.selection_weighing_factors
          )[0];

        edit.additional.funding = props.funding.filter(
          (item) => item.label === opportunityDetails?.additional.funding
        )[0];

        edit.additional.geography = props.geography.filter(
          (item) => item.label === opportunityDetails?.additional.geography
        )[0];

        // edit.additional.client_history = props.clientHistory.filter(
        //   (item) => item.label === opportunityDetails?.additional.client_history
        // )[0];

        edit.additional.client_classification =
          opportunityDetails?.additional.client_classification.map((item) => {
            return (
              props.clientClassificationV1.find(
                (option) => option.label === item.label
              ) || item
            );
          }) || [];

        edit.additional.client_type = props.clientType.filter(
          (item) => item.label === opportunityDetails?.additional.client_type
        )[0];

        edit.additional.depth_of_advisor_engagement =
          props.depthOfAdvisorEngagement.filter(
            (item) =>
              item.label ===
              opportunityDetails?.additional.depth_of_advisor_engagement
          )[0];

        edit.additional.resourcing_bid = props.resourcingTheBid.filter(
          (item) => item.label === opportunityDetails?.additional.resourcing_bid
        )[0];

        edit.additional.resourcing_project = props.resourcingTheProject.filter(
          (item) =>
            item.label === opportunityDetails?.additional.resourcing_project
        )[0];

        edit.additional.no_of_competitors = props.noOfCompetitors.filter(
          (item) =>
            item.label === opportunityDetails?.additional.no_of_competitors
        )[0];

        edit.additional.bond_requirement = props.bondRequirement.filter(
          (item) =>
            item.label === opportunityDetails?.additional.bond_requirement
        )[0];
        edit.opportunity.tender_period_opportunity = props.tenderPeriod.filter(
          (item) =>
            item.label === globalOpportunityData?.opportunity?.tender_period_opportunity
        )[0];
      }

      setEditData(edit);
    }
  };

  const getCompetitorsList = async () => {
    try {
        setLoading(true); 

        const getCompetitorsResponse = await getCompetitors(
            props.customerId,
            props.branch?.branch_id,
            props.branch?.branch_key
        );

        // Checking if response data is valid
        if (getCompetitorsResponse.data && getCompetitorsResponse.data.competitor_list) {
            setAllCompetitorsList(getCompetitorsResponse.data.competitor_list);
        } else {
            toastRef.current.showToast({
                type: 'info',
                message: 'No competitors found for the given criteria.'
            });
        }
    } catch (error) {
        toastRef.current.showToast({
            type: 'error',
            message: 'An error occurred while fetching the competitors list. Please try again or contact Admin.'
        });
    } finally {
        setLoading(false); 
    }
};


  const getFilteredCompetitors = () => {
    let filtered = [];

    if (!valueChainText || valueChainText.trim() === "") {
      filtered = allCompetitorsList.slice(0, 8);
    } else {
      const searchValue = valueChainText.toLowerCase();
      filtered = allCompetitorsList.filter((item) =>
        item.competitor_name.toLowerCase().includes(searchValue)
      );
    }
    // setNoResults(filtered.length === 0);
    setAllCompetitorsList(filtered);
    setFilteredCompetitors(filtered);
  };

  const handleInputTextChange = (id, field, value) => {
    setCompetitorList((prevList) =>
      prevList.map((item) =>
        item._id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const handleCheckboxChange = (id, checked) => {
    setCompetitorList((prevList) =>
      prevList.map((item) =>
        item._id === id ? { ...item, winner: checked } : item
      )
    );
  };

  const checkingDisplayName = (rowData) => {
    return (
      <div>
        {
          <div>
            {rowData.competitor_name != null && rowData.competitor_name != ""
              ? rowData.competitor_name
              : rowData.competitor_name}
          </div>
        }
      </div>
    );
  };

  const derivedKnownMargin = (rowData) => {
    return (
      <div>
        {
          <div>
            <InputTextElementElement
              className="dropdown-field-handle"
              value={rowData.derived_known_margin}
              name="derived_known_margin"
              placeholder="Value"
              onChange={(e) =>
                handleInputTextChange(
                  rowData._id,
                  e.target.name,
                  e.target.value
                )
              }
            />
          </div>
        }
      </div>
    );
  };

  const ranking = (rowData) => {
    return (
      <div>
        {
          <div>
            <InputTextElementElement
              className="dropdown-field-handle"
              value={rowData.ranking}
              placeholder="Value"
              name="ranking"
              onChange={(e) =>
                handleInputTextChange(
                  rowData._id,
                  e.target.name,
                  e.target.value
                )
              }
            />
          </div>
        }
      </div>
    );
  };

  const commentsData = (rowData) => {
    return (
      <div>
        {
          <div>
            <InputTextElementElement
              className="dropdown-field-handle"
              value={rowData.comments}
              placeholder="Value"
              name="comments"
              onChange={(e) =>
                handleInputTextChange(
                  rowData._id,
                  e.target.name,
                  e.target.value
                )
              }
            />
          </div>
        }
      </div>
    );
  };

  const winnerData = (rowData) => {
    return (
      <div>
        {
          <div>
            <CheckboxElement
              id={rowData._id}
              // name={`known-${ind}`}
              value={rowData.winner}
              checked={rowData.winner}
              name="winner"
              onChangeCheck={(e) =>
                handleCheckboxChange(rowData._id, e.target.checked)
              }
              className="mr-2"
            />
          </div>
        }
      </div>
    );
  };

  const columns = [
    {
      field: "competitor_name", // Field name for the column data
      header:
        oppSelectivityHeaders.find(
          (headers) => headers.header_name === "Competitor"
        )?.display_name || "", // Header text displayed in the table header
      body: checkingDisplayName, // Function to render the cell content for this column
      style: { width: "20%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "derived_known_margin", // Field name for the column data
      header:
        oppSelectivityHeaders.find(
          (headers) => headers.header_name === "Derived / Known Margin"
        )?.display_name || "", // Header text displayed in the table header
      body: derivedKnownMargin, // Function to render the cell content for this column
      style: { width: "20%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "ranking", // Field name for the column data
      header:
        oppSelectivityHeaders.find(
          (headers) => headers.header_name === "Ranking"
        )?.display_name || "", // Header text displayed in the table header
      body: ranking, // Function to render the cell content for this column
      style: { width: "20%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "comments", // Field name for the column data
      header:
        oppSelectivityHeaders.find(
          (headers) => headers.header_name === "Comments"
        )?.display_name || "", // Header text displayed in the table header
      body: commentsData, // Function to render the cell content for this column
      style: { width: "20%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "winner", // Field name for the column data
      header:
        oppSelectivityHeaders.find(
          (headers) => headers.header_name === "Winner"
        )?.display_name || "", // Header text displayed in the table header
      body: winnerData, // Function to render the cell content for this column
      style: { width: "20%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const handleValueChainChange = (e) => {
    setValueChainName(e.target.value);
  };

  const addRowPopup = () => {
    setAddRowsPopup(true);
  };
  const closeAddRowPopup = () => {
    setLoading(false)
    setAddRowsPopup(false);
    setValueChain('');
    setValueChainName('')
    setValueChainText('')
  };

  // Remove selected rows
  const deleteRows = () => {
    const updatedList = competitorList.filter(
      (row) => !selectedRows.includes(row)
    );
    setCompetitorList(updatedList);
    setSelectedRows([]);
  };

  const rowClick = (selected) => {
    setSelectedRows(selected);
  };

  const handleValueChain = (value) => {
    setValueChain(value);
  };

  function generateRandomID() {
    const hexChars = "0123456789abcdef";
    let result = "";
    for (let i = 0; i < 24; i++) {
      result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
    }
    return result;
  }

  const addExistCompetitor = () => {
    setLoading(true)
    if (valueChainText && valueChainText.trim() !== "") {
      const valid = allCompetitorsList.find(
        (item) =>
          item.competitor_name.toLowerCase() === valueChainText.toLowerCase()
      );

      if (valid) {
        const found = competitorList.find(
          (item) =>
            item.competitor_name.toLowerCase() === valueChainText.toLowerCase()
        );

        if (!found) {
          // Flatten the competitor list before adding the new competitor
          // const currentCompetitorList = props.opportunityData.additional.competitor_list.flat();
          const updatedList = {
            _id: generateRandomID(),
            competitor_name: valueChainText,
            comments: "",
            winner: false,
            derived_known_margin: "",
            ranking: "",
          };
          setCompetitorList([...competitorList, updatedList]);
          toastRef.current.showToast({
            type: "success",
            message: "Competitor Added",
          });
          setAddRowsPopup(false);
          // Update the competitor list in the parent component or state
          // props.updateCompetitorList(updatedList);
        } else {
          toastRef.current.showToast({
            type: "error",
            message: "The competitor name already exists in the list",
          });
        }
      } else {
        toastRef.current.showToast({
          type: "error",
          message: "Invalid Competitor Name",
        });
      }
      setLoading(false)
    } else {
      toastRef.current.showToast({
        type: "error",
        message: "Competitor name should not be empty",
      });
      setLoading(false)
    }
    setValueChain('')
    setValueChainText('')
  };

  const addNewCompetitor = async () => {
    setLoading(true); 

    try {
        // Checking if competitor already exists in the list
        const found = competitorList.some(
            (item) => item.competitor_name.toLowerCase() === valueChainName.toLowerCase()
        );

        if (found) {
            // Competitor name already exists in the list
            toastRef.current.showToast({
                type: "error",
                message: "The competitor name already exists in the list",
            });
        } else {
            // Add new competitor to the list
            const updatedList = [
                ...competitorList,
                {
                    _id: generateRandomID(),
                    competitor_name: valueChainName,
                    comments: "",
                    winner: false,
                    derived_known_margin: "",
                    ranking: "",
                },
            ];

            setCompetitorList(updatedList);

            // Checking if competitor is in the customer list
            const custFound = allCompetitorsList.some(
                (item) => item.competitor_name.toLowerCase() === valueChainName.toLowerCase()
            );

            if (!custFound) {
                // Make API call to update competitor
                const updateCompetitorResponse = await updateCompetitor(
                    props.customerId,
                    valueChainName,
                    props.branch.branch_id,
                    props.branch.branch_key
                );

                if (updateCompetitorResponse.status === 200) {
                    toastRef.current.showToast({
                        type: "success",
                        message: `${updateCompetitorResponse.data.message}`,
                    });
                    getCompetitorsList(); 
                    setAddRowsPopup(false); 
                }
            } else {
                // Competitor already exists in the customer list
                toastRef.current.showToast({
                    type: "error",
                    message: "The competitor name already exists in the customer list",
                });
            }
        }
    } catch (error) {
        console.error("Error adding competitor:", error);
        toastRef.current.showToast({
            type: "error",
            message: "An error occurred while adding the competitor. Please try again.",
        });
    } finally {
        setLoading(false);
        setValueChain('');
        setValueChainName('');
    }
};




  const getCustomerData = async () => {
    try {
        // Checking if customerId exists before making the API call
        if (props?.customerId) {
            setLoading(true);

            const customer = await getCustomer(props.customerId);

            // Checking if the API response contains valid data
            if (customer.data) {
                setCustomerTooltipData(customer.data.tooltips?.pipeline?.selectivity || '');
            } else {
                toastRef.current.showToast({
                    type: 'info',
                    message: 'No customer data found for the provided customer ID.'
                });
            }
        } else {
            toastRef.current.showToast({
                type: 'warning',
                message: 'Customer ID is missing. Please provide a valid ID.'
            });
        }
    } catch (error) {
        toastRef.current.showToast({
            type: 'error',
            message: 'An error occurred while fetching customer data. Please try again later.'
        });
    } finally {
        setLoading(false);
    }
};


  const renderFooter = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          {valueChain === "Yes" && (
            <ButtonElement
              type="submit"
              label="Add"
              className="save-button"
              onClick={() => addExistCompetitor()}
            />
          )}
          {valueChain === "No" && (
            <ButtonElement
              type="submit"
              label="Add"
              className="save-button"
              onClick={() => addNewCompetitor()}
            />
          )}
        </div>
      </div>
    );
  };

  const handleCode = (value) => {
    setGlobalOpportunityData((prevOpportunityDetails) => ({
      ...prevOpportunityDetails,
      ["additional"]: {
        ...prevOpportunityDetails["additional"],
        ["project_post_code"]: value,
      },
    }));
    setValue(
      "project_address",
      opportunityData?.additional.project_location + "\n" + value
    );
  };


  const handleButtonClick = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
      setShowVideo(false);
  };

  return (
    <>
      <div className="col-md-12 text-right">
          <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
      </div>
      {props.opportunityData &&
        !_.isUndefined(editData) &&
        props.projectSelectSections?.map((section, index) => {
          return (
            <div key={index} className="mt-10">
              <ToastElement ref={toastRef} />
              <Loader loading={loading} />
              
              <Accordion activeIndex={0}>
                <AccordionTab header={section?.display_name} disabled>
                  {section.ESG_section_name === "Project" && (
                    <div className="new-field d-flex">
                      <div className="col-md-6 pl-0">
                        {props.projectSumFields?.find(
                          (project) => project.field_name === "Project ID"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSumFields?.find(
                                  (project) =>
                                    project.field_name === "Project ID"
                                ).display_name || ""}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0"></div>
                            <div className="col pr-0">
                              <label className="form-label text-left">
                                {props.opportunityData.opportunity_seq}
                              </label>
                            </div>
                          </div>
                        )}
                        {props.projectFieldsNew?.find(
                          (project) => project.field_name === "Project Name"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  props.projectFieldsNew?.find(
                                    (project) =>
                                      project.field_name === "Project Name"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0"></div>
                            <div className="col pr-0">
                              <InputTextElementElement
                                value={
                                  globalOpportunityData &&
                                  globalOpportunityData.opportunity_name
                                }
                                onChange={(e) =>
                                  setGlobalOpportunityData((prevData) => ({
                                    ...prevData,
                                    opportunity_name: e.target.value,
                                  }))
                                }
                                placeholder="Text"
                                name="opportunity_name"
                                className="w-full"
                              />
                            </div>
                          </div>
                        )}
                        {props.projectSumFields?.find(
                          (project) =>
                            project.field_name === "Project Description"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  props.projectSumFields?.find(
                                    (project) =>
                                      project.field_name ===
                                      "Project Description"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0"></div>
                            <div className="col pr-0">
                              <TextareaElement
                                id="client_description"
                                name="client_description"
                                defaultValue={
                                  globalOpportunityData &&
                                  globalOpportunityData?.summary
                                    ?.opportunity_description
                                }
                                value={globalOpportunityData?.summary?.opportunity_description}
                                onChange={(e) =>
                                  setGlobalOpportunityData((prevData) => ({
                                    ...prevData,
                                    summary: {
                                      ...prevData.summary,
                                      opportunity_description: e.target.value,
                                    },
                                  }))
                                }
                                className="w-full"
                                rows={3}
                              />
                            </div>
                          </div>
                        )}
                        {props.projectSelectFields?.find(
                          (project) => project.field_name === "Client meetings"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  props.projectSelectFields?.find(
                                    (project) =>
                                      project.field_name === "Client meetings"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity?.client_meetings
                                ?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.client_meetings?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="ClientMeetings"
                                control={control}
                                defaultValue={
                                  props.clientMeetings.filter(
                                    (item) =>
                                      item.label === globalOpportunityData?.opportunity?.client_meetings
                                  )[0]
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="ClientMeetings"
                                      name="ClientMeetings"
                                      options={(props.clientMeetings != undefined && props.clientMeetings.length > 0) ? props.clientMeetings : []}
                                      value={
                                        field.value ||
                                        props.clientMeetings.filter(
                                          (item) =>
                                            item.label === globalOpportunityData?.opportunity?.client_meetings
                                        )[0]
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      {...field}
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["ClientMeetings"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            client_meetings: e.value.label,
                                          }
                                        }));
                                        props.computeScore(0, "ClientMeetings", e.value, props.clientMeetings.filter(
                                          (item) =>
                                            item.label === globalOpportunityData?.opportunity?.client_meetings
                                        )[0]);
                                        field.onChange(e.value)}
                                    }
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.projectSelectFields?.find(
                          (project) =>
                            project.field_name ===
                            "Connections to Professional Team"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  props.projectSelectFields?.find(
                                    (project) =>
                                      project.field_name ===
                                      "Connections to Professional Team"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity
                                ?.connections_professional_team?.status ==
                                true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.connections_professional_team?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="ConnectionsToProfessionalTeam"
                                control={control}
                                defaultValue={
                                  props.connectionsToProfessionalTeam.filter(
                                    (item) =>
                                      item.label ===
                                      globalOpportunityData?.opportunity?.connections_professional_team
                                  )[0]
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="ConnectionsToProfessionalTeam"
                                      name="ConnectionsToProfessionalTeam"
                                      options={
                                      (props.connectionsToProfessionalTeam != undefined && props.connectionsToProfessionalTeam.length > 0) ? props.connectionsToProfessionalTeam : []
                                      }
                                      value={
                                        field.value ||
                                        props.connectionsToProfessionalTeam.filter(
                                          (item) =>
                                            item.label ===
                                            globalOpportunityData?.opportunity?.connections_professional_team
                                        )[0]
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      {...field}
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["ConnectionsToProfessionalTeam"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            connections_professional_team: e.value.label,
                                          }
                                        }));
                                        props.computeScore(
                                          0,
                                          "ConnectionsToProfessionalTeam",
                                          e.value,
                                          props.connectionsToProfessionalTeam.filter(
                                            (item) =>
                                              item.label ===
                                              globalOpportunityData?.opportunity?.connections_professional_team
                                          )[0]
                                        );
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {props.projectFieldsNew?.find(
                          (project) => project.field_name === "Type"
                        )?.field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  props.projectFieldsNew?.find(
                                    (project) => project.field_name === "Type"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0"></div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="opportunityType"
                                control={control}
                                defaultValue={editData.services}
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="opportunityType"
                                      name="opportunityType"
                                      {...field}
                                      options={(props.opportunityType != undefined && props.opportunityType.length > 0) ? props.opportunityType : []}
                                      value={field.value || editData.services}
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["opportunityType"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          services: e.value.label
                                        }));
                                        props.computeScore(
                                          1,
                                          "opportunityType",
                                          e.value,
                                          editData.services
                                        );
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {props.projectSumFields?.find(
                          (project) => project.field_name === "Work Type"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSumFields?.find(
                                  (project) =>
                                    project.field_name === "Work Type"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0"></div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="WorkType"
                                control={control}
                                defaultValue={props.workType.filter(
                                  (item) => item.label === globalOpportunityData?.summary?.work_type
                                )[0]}
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="WorkType"
                                      name="WorkType"
                                      {...field}
                                      options={(props.workType != undefined && props.workType.length > 0) ? props.workType : []}
                                      value={
                                        field.value ||
                                        props.workType.filter(
                                          (item) => item.label === globalOpportunityData?.summary?.work_type
                                        )[0]
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["WorkType"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          summary: {
                                            ...prevData.summary,
                                            work_type: e.value.label,
                                          }
                                        }));
                                        props.computeScore(1, "WorkType", e.value, props.workType.filter(
                                          (item) => item.label === globalOpportunityData?.summary?.work_type
                                        )[0]);
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.opportunityData.opportunity
                          ?.existing_framework == "yes" && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                Framework Length:
                              </label>
                            </div>
                            <div className="col-md-1 pl-0"></div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="frameworkLength"
                                control={control}
                                defaultValue={
                                  editData.opportunity?.framework_length
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                      }}
                                      id="frameworkLength"
                                      {...field}
                                      options={(props.frameworkLength != undefined && props.frameworkLength.length > 0) ? props.frameworkLength : []}
                                      value={
                                        field.value ||
                                        editData.opportunity?.framework_length
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.projectSelectFields?.find(
                          (project) => project.field_name === "Project Type"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSelectFields.find(
                                  (project) =>
                                    project.field_name === "Project Type"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity?.project_type
                                ?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.project_type?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="ProjectType"
                                control={control}
                                defaultValue={
                                  props.projectType.filter(
                                    (item) => item.label === globalOpportunityData?.opportunity?.project_type
                                  )[0]
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="ProjectType"
                                      name="ProjectType"
                                      {...field}
                                      options={(props.projectType != undefined && props.projectType.length > 0) ? props.projectType : []}
                                      value={
                                        field.value ||
                                        props.projectType.filter(
                                          (item) => item.label === globalOpportunityData?.opportunity?.project_type
                                        )[0]
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["ProjectType"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            project_type: e.value.label,
                                          }
                                        }));
                                        props.computeScore(0, "ProjectType", e.value, props.projectType.filter(
                                          (item) => item.label === globalOpportunityData?.opportunity?.project_type
                                        )[0]);
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.projectSelectFields?.find(
                          (project) =>
                            project.field_name === "Source of Opportunity"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSelectFields.find(
                                  (project) =>
                                    project.field_name ===
                                    "Source of Opportunity"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity
                                ?.source_opportunity?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.source_opportunity?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="SourceOfOpportunity"
                                control={control}
                                defaultValue={
                                  props.sourceOfOpportunity.filter(
                                    (item) =>
                                      item.label === globalOpportunityData?.opportunity?.source_opportunity
                                  )[0]
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="SourceOfOpportunity"
                                      name="SourceOfOpportunity"
                                      options={(props.sourceOfOpportunity != undefined && props.sourceOfOpportunity.length > 0) ? props.sourceOfOpportunity : []}
                                      value={
                                        field.value ||
                                        props.sourceOfOpportunity.filter(
                                          (item) =>
                                            item.label === globalOpportunityData?.opportunity?.source_opportunity
                                        )[0]
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      {...field}
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["SourceOfOpportunity"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            source_opportunity: e.value.label,
                                          }
                                        }));
                                        props.computeScore(
                                          0,
                                          "SourceOfOpportunity",
                                          e.value,
                                          props.sourceOfOpportunity.filter(
                                            (item) =>
                                              item.label === globalOpportunityData?.opportunity?.source_opportunity
                                          )[0]
                                        );
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 pl-0">
                        {props.commanFieldsNew?.find(
                          (project) =>
                            project.field_name === "Work Classification"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.commanFieldsNew.find(
                                  (project) =>
                                    project.field_name === "Work Classification"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity
                                ?.work_classification?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.work_classification?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="work_classification"
                                control={control}
                                defaultValue={
                                  editData.opportunity?.work_classification
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="work_classification"
                                      {...field}
                                      options={(props.workClassificationV2 != undefined && props.workClassificationV2.length > 0) ? props.workClassificationV2 : []}
                                      value={
                                        field.value ||
                                        editData.opportunity
                                          ?.work_classification
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            work_classification: e.value.label,
                                          }
                                        }));
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.projectSumFields?.find(
                          (project) => project.field_name === "Form of Contract"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSumFields.find(
                                  (project) =>
                                    project.field_name === "Form of Contract"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0"></div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="FormOfContractV1"
                                control={control}
                                defaultValue={props.formOfContract1.filter(
                                  (item) => item.label === globalOpportunityData?.summary?.form_of_contract
                                )[0]}
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="FormOfContractV1"
                                      name="FormOfContractV1"
                                      options={(props.formOfContract1 != undefined && props.formOfContract1.length > 0) ? props.formOfContract1 : []}
                                      value={
                                        field.value ||
                                        props.formOfContract1.filter(
                                          (item) => item.label === globalOpportunityData?.summary?.form_of_contract
                                        )[0]
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      {...field}
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["FormOfContractV1"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          summary: {
                                            ...prevData.summary,
                                            form_of_contract: e.value.label,
                                          }
                                        }));
                                        props.computeScore(
                                          1,
                                          "FormOfContractV1",
                                          e.value,
                                          props.formOfContract1.filter(
                                            (item) => item.label === globalOpportunityData?.summary?.form_of_contract
                                          )[0]
                                        );
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {props.projectSumFields?.find(
                          (project) =>
                            project.field_name === "Procurement Route"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSumFields.find(
                                  (project) =>
                                    project.field_name === "Procurement Route"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0"></div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="ProcurementRoute"
                                control={control}
                                defaultValue={
                                  props.procurementRoute.filter(
                                    (item) => item.label === globalOpportunityData?.summary?.procurement_route
                                  )[0]
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="ProcurementRoute"
                                      name="ProcurementRoute"
                                      options={(props.procurementRoute != undefined && props.procurementRoute.length > 0) ? props.procurementRoute : []}
                                      value={
                                        field.value ||
                                        props.procurementRoute.filter(
                                          (item) => item.label === globalOpportunityData?.summary?.procurement_route
                                        )[0]
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      {...field}
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["ProcurementRoute"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          summary: {
                                            ...prevData.summary,
                                            procurement_route: e.value.label,
                                          }
                                        }));
                                        props.computeScore(
                                          1,
                                          "ProcurementRoute",
                                          e.value,
                                          props.procurementRoute.filter(
                                            (item) => item.label === globalOpportunityData?.summary?.procurement_route
                                          )[0]
                                        );
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.projectSelectFields?.find(
                          (project) => project.field_name === "Tender Period"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSelectFields.find(
                                  (project) =>
                                    project.field_name === "Tender Period"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity
                                ?.tender_period_opportunity?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.tender_period_opportunity?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="TenderPeriod"
                                control={control}
                                defaultValue={editData?.opportunity?.tender_period_opportunity}
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="TenderPeriod"
                                      name="TenderPeriod"
                                      options={(props.tenderPeriod != undefined && props.tenderPeriod.length > 0) ? props.tenderPeriod : []}
                                      value={editData?.opportunity?.tender_period_opportunity}
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      // disabled={true}
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["TenderPeriod"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            tender_period_opportunity: e.value.label,
                                          }
                                        }));
                                        props.computeScore(0, "TenderPeriod", e.value, editData?.opportunity?.tender_period_opportunity);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.projectSelectFields?.find(
                          (project) => project.field_name === "Contract Range"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSelectFields.find(
                                  (project) =>
                                    project.field_name === "Contract Range"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity?.project_value
                                ?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.project_value?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="ProjectValue"
                                control={control}
                                defaultValue={
                                  editData.opportunity?.project_value
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="ProjectValue"
                                      name="ProjectValue"
                                      options={(props.projectValue != undefined && props.projectValue.length > 0) ? props.projectValue : []}
                                      value={
                                        field.value ||
                                        editData.opportunity?.project_value
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      {...field}
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["ProjectValue"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            project_value: e.value.label,
                                          }
                                        }));
                                        props.computeScore(
                                          0,
                                          "ProjectValue",
                                          e.value,
                                          editData.opportunity?.project_value
                                        );
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.projectSelectFields?.find(
                          (project) => project.field_name === "Project Margin"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSelectFields.find(
                                  (project) =>
                                    project.field_name === "Project Margin"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity?.project_margin
                                ?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.project_margin?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="projectMargin"
                                control={control}
                                defaultValue={
                                  editData.opportunity?.project_margin
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="ProjectMargin"
                                      name="ProjectMargin"
                                      {...field}
                                      options={(props.projectMargin != undefined && props.projectMargin.length > 0) ? props.projectMargin : []}
                                      value={
                                        field.value ||
                                        editData.opportunity?.project_margin
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["ProjectMargin"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            project_margin: e.value.label,
                                          }
                                        }));
                                        props.computeScore(
                                          0,
                                          "ProjectMargin",
                                          e.value,
                                          editData.opportunity?.project_margin
                                        );
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {props.projectSelectFields?.find(
                          (project) => project.field_name === "Project Duration"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSelectFields.find(
                                  (project) =>
                                    project.field_name === "Project Duration"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity
                                ?.project_duration?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.project_duration?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <DropdownElement
                                id="ProjectDuration"
                                name="ProjectDuration"
                                options={(props.projectDuration != undefined && props.projectDuration.length > 0) ? props.projectDuration : []}
                                value={props.projectDuration.find(
                                  (obj) =>
                                    obj.label ===
                                    globalOpportunityData?.opportunity?.project_duration
                                ) || props.projectDuration.find(
                                  (obj) =>
                                    obj.label ===
                                    props.opportunityData.opportunity
                                      ?.project_duration
                                )}
                                optionLabel="label"
                                placeholder="-- Please select --"
                                className="w-full"
                                // disabled={true}
                                // ref={(el) => {
                                //   props.setElement((prevData) => ({
                                //     ...prevData,
                                //     ["ProjectDuration"]: el,
                                //   }));
                                // }}
                                onChange={(e) => {
                                  setGlobalOpportunityData((prevData) => ({
                                    ...prevData,
                                    opportunity: {
                                      ...prevData.opportunity,
                                      project_duration: e.value.label,
                                    }
                                  }));
                                  props.computeScore(0, "ProjectDuration", e.value, props.projectDuration.find(
                                    (obj) =>
                                      obj.label ===
                                      props.opportunityData.opportunity
                                        ?.project_duration
                                  ));
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.projectSelectFields?.find(
                          (project) => project.field_name === "Risks"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSelectFields.find(
                                  (project) => project.field_name === "Risks"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity?.risks
                                ?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity?.risks
                                        ?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="Risks"
                                control={control}
                                defaultValue={props.risks.filter(
                                  (item) => item.label === globalOpportunityData?.opportunity?.risks
                                )[0]}
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="Risks"
                                      name="Risks"
                                      options={(props.risks != undefined && props.risks.length > 0) ? props.risks : []}
                                      value={
                                        field.value ||
                                        props.risks.filter(
                                          (item) => item.label === globalOpportunityData?.opportunity?.risks
                                        )[0]
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      {...field}
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["Risks"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            risks: e.value.label,
                                          }
                                        }));
                                        props.computeScore(0, "Risks", e.value, props.risks.filter(
                                          (item) => item.label === globalOpportunityData?.opportunity?.risks
                                        )[0]);
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {props.projectSelectFields?.find(
                          (project) => project.field_name === "BIM Requirement"
                        ).field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {props.projectSelectFields.find(
                                  (project) =>
                                    project.field_name === "BIM Requirement"
                                ).display_name || null}
                                :
                              </label>
                            </div>
                            <div className="col-md-1 pl-0">
                              {customerTooltipData?.opportunity?.bim_requirement
                                ?.status == true && (
                                <div>
                                  <Tooltip target=".custom-target-icon" />
                                  <i
                                    className="custom-target-icon pi pi-info-circle tooltip-font"
                                    data-pr-tooltip={
                                      customerTooltipData?.opportunity
                                        ?.bim_requirement?.text
                                    }
                                    data-pr-position="right"
                                  ></i>
                                </div>
                              )}
                            </div>
                            <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                              <Controller
                                name="BimRequirement"
                                control={control}
                                defaultValue={
                                  editData.opportunity?.bim_requirement
                                }
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="BimRequirement"
                                      name="BimRequirement"
                                      {...field}
                                      options={(props.bimRequirement != undefined && props.bimRequirement.length > 0) ? props.bimRequirement : []}
                                      value={
                                        field.value ||
                                        editData.opportunity?.bim_requirement
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["BimRequirement"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            bim_requirement: e.value.label,
                                          }
                                        }));
                                        props.computeScore(
                                          0,
                                          "BimRequirement",
                                          e.value,
                                          editData.opportunity?.bim_requirement
                                        );
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {section.ESG_section_name === "Additional" && (
                    <div>
                      <div className="new-field d-flex">
                        <div className="col-md-6 pl-0">
                          {props.projectSelectFields?.find(
                            (project) =>
                              project.field_name === "Fit with Business Plan"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name ===
                                      "Fit with Business Plan"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional
                                  ?.fit_with_business_plan?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.fit_with_business_plan?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="fitWithBusinessPlan"
                                  control={control}
                                  defaultValue={
                                    editData.additional?.fit_with_business_plan
                                  }
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="FitWithBusinessPlan"
                                        name="FitWithBusinessPlan"
                                        {...field}
                                        options={(props.fitWithBusinessPlan != undefined && props.fitWithBusinessPlan.length > 0) ? props.fitWithBusinessPlan : []}
                                        value={
                                          field.value ||
                                          editData.additional
                                            ?.fit_with_business_plan
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["FitWithBusinessPlan"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              fit_with_business_plan: e.value.label,
                                            }
                                          }));
                                          props.computeScore(0, "FitWithBusinessPlan", e.value, editData.additional
                                            ?.fit_with_business_plan);
                                          field.onChange(e.value)}
                                      }
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) => project.field_name === "Profile"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name === "Profile"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional?.profile
                                  ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional?.profile
                                          ?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="profile"
                                  control={control}
                                  defaultValue={editData.additional?.profile}
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="Profile"
                                        name="Profile"
                                        {...field}
                                        options={(props.profile != undefined && props.profile.length > 0) ? props.profile : []}
                                        value={
                                          field.value ||
                                          editData.additional?.profile
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["Profile"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              profile: e.value.label,
                                            }
                                          }));
                                          props.computeScore(0, "Profile", e.value, editData.additional?.profile);
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) =>
                              project.field_name === "Payment Terms (Days)"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name ===
                                      "Payment Terms (Days)"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional?.payment_terms
                                  ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.payment_terms?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="PaymentTermsDays"
                                  control={control}
                                  defaultValue={
                                    editData.additional?.payment_terms
                                  }
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="PaymentTermsDays"
                                        name="PaymentTermsDays"
                                        options={(props.paymentTermsDays != undefined && props.paymentTermsDays.length > 0) ? props.paymentTermsDays : []}
                                        value={
                                          field.value ||
                                          editData.additional?.payment_terms
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["PaymentTermsDays"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              payment_terms: e.value.label,
                                            }
                                          }));
                                          props.computeScore(
                                            0,
                                            "PaymentTermsDays",
                                            e.value,
                                            editData.additional?.payment_terms
                                          );
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) => project.field_name === "Winnability"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name === "Winnability"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional?.winnability
                                  ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.winnability?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="winnability"
                                  control={control}
                                  defaultValue={editData.additional?.winnability}
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="Winnability"
                                        name="Winnability"
                                        options={(props.winnability != undefined && props.winnability.length > 0) ? props.winnability : []}
                                        value={
                                          field.value ||
                                          editData.additional?.winnability
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["Winnability"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              winnability: e.value.label,
                                            }
                                          }));
                                          props.computeScore(0, "Winnability", e.value, editData.additional?.winnability);
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) =>
                              project.field_name ===
                              "Selection / weighing factors"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name ===
                                      "Selection / weighing factors"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional
                                  ?.selection_weighing_factors?.status ==
                                  true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.selection_weighing_factors?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="SelectionweightingFactors"
                                  control={control}
                                  defaultValue={
                                    editData.additional
                                      ?.selection_weighing_factors
                                  }
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="SelectionweightingFactors"
                                        name="SelectionweightingFactors"
                                        options={
                                          (props.selectionWeightingFactors != undefined && props.selectionWeightingFactors.length > 0) ? props.selectionWeightingFactors : []
                                        }
                                        value={
                                          field.value ||
                                          editData.additional
                                            ?.selection_weighing_factors
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["SelectionweightingFactors"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              selection_weighing_factors: e.value.label,
                                            }
                                          }));
                                          props.computeScore(
                                            0,
                                            "SelectionweightingFactors",
                                            e.value,
                                            editData.additional
                                            ?.selection_weighing_factors
                                          );
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) => project.field_name === "Funding"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name === "Funding"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional?.funding
                                  ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional?.funding
                                          ?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="Funding"
                                  control={control}
                                  defaultValue={editData.additional?.funding}
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="Funding"
                                        name="Funding"
                                        options={(props.funding != undefined && props.funding.length > 0) ? props.funding : []}
                                        value={
                                          field.value ||
                                          editData.additional?.funding
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["Funding"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              funding: e.value.label,
                                            }
                                          }));
                                          props.computeScore(0, "Funding", e.value, editData.additional?.funding);
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) =>
                              project.field_name === "Funding Details"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name === "Funding Details"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional
                                  ?.funding_details?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.funding_details?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col pr-0">
                                <Controller
                                  name="funding_details"
                                  control={control}
                                  defaultValue={props.opportunityData?.additional?.funding_details}
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <InputTextElementElement
                                        placeholder="Text"
                                        name="funding_details"
                                        className="w-full"
                                        {...field}
                                        value={field.value || props.opportunityData?.additional?.funding_details}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              funding_details: e.target.value,
                                            }
                                          }))
                                          field.onChange(e.target.value)
                                        }
                                        }
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) => project.field_name === "Geography"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name === "Geography"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional?.geography
                                  ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.geography?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="Geography"
                                  control={control}
                                  defaultValue={editData.additional?.geography}
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="Geography"
                                        name="Geography"
                                        {...field}
                                        options={(props.geography != undefined && props.geography.length > 0) ? props.geography : []}
                                        value={
                                          field.value ||
                                          editData.additional?.geography
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["Geography"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              geography: e.value.label,
                                            }
                                          }));
                                          props.computeScore(0, "Geography", e.value, editData.additional?.geography);
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 pl-0">
                          {props.commanFieldsNew?.find(
                            (project) => project.field_name === "Business Unit"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.commanFieldsNew.find(
                                    (project) =>
                                      project.field_name === "Business Unit"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0"></div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="businessUnit"
                                  control={control}
                                  defaultValue={editData.business_unit}
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="businessUnit"
                                        {...field}
                                        options={(props.businessUnit != undefined && props.businessUnit.length > 0) ? props.businessUnit : []}
                                        value={
                                          field.value || editData.business_unit
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            business_unit: e.value.label
                                          }));
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) => project.field_name === "Client History"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name === "Client History"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0"></div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="clientHistory"
                                  control={control}
                                  defaultValue={
                                    props.clientHistory.filter(
                                      (item) => item.label === globalOpportunityData?.additional?.client_history
                                    )[0]
                                  }
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="clientHistory"
                                        name="ClientHistory"
                                        options={(props.clientHistory != undefined && props.clientHistory.length > 0) ? props.clientHistory : []}
                                        value={
                                          field.value ||
                                          props.clientHistory.filter(
                                            (item) => item.label === globalOpportunityData?.additional?.client_history
                                          )[0]
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["ClientHistory"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              client_history: e.value.label,
                                            }
                                          }));
                                          props.computeScore(
                                            0,
                                            "ClientHistory",
                                            e.value,
                                            props.clientHistory.filter(
                                              (item) => item.label === globalOpportunityData?.additional?.client_history
                                            )[0]
                                          );
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) =>
                              project.field_name ===
                              "Depth of Advisor Engagement"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name ===
                                      "Depth of Advisor Engagement"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional
                                  ?.depth_of_advisor_engagement?.status ==
                                  true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.depth_of_advisor_engagement?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="DepthOfAdvisorEngagement"
                                  control={control}
                                  defaultValue={
                                    editData.additional
                                      ?.depth_of_advisor_engagement
                                  }
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="DepthOfAdvisorEngagement"
                                        name="DepthOfAdvisorEngagement"
                                        options={(props.depthOfAdvisorEngagement != undefined && props.depthOfAdvisorEngagement.length > 0) ? props.depthOfAdvisorEngagement : []}
                                        value={
                                          field.value ||
                                          editData.additional
                                            ?.depth_of_advisor_engagement
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["DepthOfAdvisorEngagement"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              depth_of_advisor_engagement: e.value.label,
                                            }
                                          }));
                                          props.computeScore(
                                            0,
                                            "DepthOfAdvisorEngagement",
                                            e.value,
                                            editData.additional
                                            ?.depth_of_advisor_engagement
                                          );
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) =>
                              project.field_name === "Resourcing the Bid"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name ===
                                      "Resourcing the Bid"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional?.resourcing_bid
                                  ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.resourcing_bid?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="ResourcingTheBid"
                                  control={control}
                                  defaultValue={
                                    editData.additional?.resourcing_bid
                                  }
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="ResourcingTheBid"
                                        name="ResourcingTheBid"
                                        options={(props.resourcingTheBid != undefined && props.resourcingTheBid.length > 0) ? props.resourcingTheBid : []}
                                        value={
                                          field.value ||
                                          editData.additional?.resourcing_bid
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["ResourcingTheBid"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              resourcing_bid: e.value.label,
                                            }
                                          }));
                                          props.computeScore(
                                            0,
                                            "ResourcingTheBid",
                                            e.value,
                                            editData.additional?.resourcing_bid
                                          );
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) =>
                              project.field_name === "Resourcing the Project"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name ===
                                      "Resourcing the Project"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional
                                  ?.resourcing_project?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.resourcing_project?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="ResourcingTheProject"
                                  control={control}
                                  defaultValue={
                                    editData.additional?.resourcing_project
                                  }
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="ResourcingTheProject"
                                        name="ResourcingTheProject"
                                        options={(props.resourcingTheProject != undefined && props.resourcingTheProject.length > 0) ? props.resourcingTheProject : []}
                                        value={
                                          field.value ||
                                          editData.additional?.resourcing_project
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["ResourcingTheProject"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              resourcing_project: e.value.label,
                                            }
                                          }));
                                          props.computeScore(
                                            0,
                                            "ResourcingTheProject",
                                            e.value,
                                            editData.additional?.resourcing_project
                                          );
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) =>
                              project.field_name === "No. of Competitors"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name ===
                                      "No. of Competitors"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional
                                  ?.no_of_competitors?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.no_of_competitors?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="NoOfCompetitorsV2"
                                  control={control}
                                  defaultValue={
                                    editData.additional?.no_of_competitors
                                  }
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="NoOfCompetitorsV2"
                                        name="NoOfCompetitorsV2"
                                        options={(props.noOfCompetitors != undefined && props.noOfCompetitors.length > 0) ? props.noOfCompetitors : []}
                                        value={
                                          field.value ||
                                          editData.additional?.no_of_competitors
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        {...field}
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["NoOfCompetitorsV2"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              no_of_competitors: e.value.label,
                                            }
                                          }));
                                          props.computeScore(
                                            0,
                                            "NoOfCompetitorsV2",
                                            e.value,
                                            editData.additional?.no_of_competitors
                                          );
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {props.projectSelectFields?.find(
                            (project) =>
                              project.field_name === "Bond Requirement"
                          ).field_status && (
                            <div className="form-group row align-items-center mb-0 mt-0">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name === "Bond Requirement"
                                  ).display_name || null}
                                  :
                                </label>
                              </div>
                              <div className="col-md-1 pl-0">
                                {customerTooltipData?.additional
                                  ?.bond_requirement?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />
                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        customerTooltipData?.additional
                                          ?.bond_requirement?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-7 pr-0 pad-t-8 pad-b-8">
                                <Controller
                                  name="BondRequirement"
                                  control={control}
                                  defaultValue={
                                    editData.additional?.bond_requirement
                                  }
                                  style={{ innerHeight: 10 }}
                                  render={({ field }) => {
                                    return (
                                      <DropdownElement
                                        id="BondRequirement"
                                        name="BondRequirement"
                                        {...field}
                                        options={(props.bondRequirement != undefined && props.bondRequirement.length > 0) ? props.bondRequirement : []}
                                        value={
                                          field.value ||
                                          editData.additional?.bond_requirement
                                        }
                                        optionLabel="label"
                                        placeholder="-- Please select --"
                                        className="w-full"
                                        // ref={(el) => {
                                        //   props.setElement((prevData) => ({
                                        //     ...prevData,
                                        //     ["BondRequirement"]: el,
                                        //   }));
                                        // }}
                                        onChange={(e) => {
                                          setGlobalOpportunityData((prevData) => ({
                                            ...prevData,
                                            additional: {
                                              ...prevData.additional,
                                              bond_requirement: e.value.label,
                                            }
                                          }));
                                          props.computeScore(
                                            0,
                                            "BondRequirement",
                                            e.value,
                                            editData.additional?.bond_requirement
                                          );
                                          field.onChange(e.value);
                                        }}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {oppSelectivityTableStatus && (
                        <div className="mt-30">
                          <div className="flex justify-content-between w-full mb-20">
                            <div className="fs-16 fw-600 mar-b-3">
                              {oppSelectivityTableHeading &&
                                oppSelectivityTableHeading}
                            </div>
                            <div className="delete-icon">
                              <ButtonElement
                                type="button"
                                className="edit-option-button ml-20"
                                icon="pi pi-trash"
                                onClick={deleteRows}
                                disabled={selectedRows.length === 0}
                              />
                              <ButtonElement
                                type="button"
                                className="edit-option-button ml-10"
                                icon="pi pi-plus"
                                onClick={addRowPopup}
                              />
                            </div>
                          </div>
                          <DataTable
                            value={competitorList}
                            columns={columns}
                            dataKey="_id"
                            isNotReorder={true}
                            rowClick={rowClick}
                          />
                        </div>
                      )}
                      <Dialog
                        visible={addRowsPopup}
                        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                        header={
                          props.projectSelectFields.find(
                            (project) =>
                              project.field_name === "Insights and Priorities"
                          )?.display_name || null
                        }
                        modal
                        footer={renderFooter}
                        onHide={closeAddRowPopup}
                        className="table-dialog width-32"
                        draggable={false}
                        position="right"
                      >
                        <div className="confirmation-content">
                          <RadioElement
                            id="remaindar"
                            options={[
                              {
                                key: "Yes",
                                name: ` Find Existing ${
                                  props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name ===
                                      "Insights and Priorities"
                                  )?.display_name
                                }`,
                              },
                              {
                                key: "No",
                                name: ` Add New ${
                                  props.projectSelectFields.find(
                                    (project) =>
                                      project.field_name ===
                                      "Insights and Priorities"
                                  )?.display_name
                                }`,
                              },
                            ]}
                            // value={surveyConfigForm.remaindar}
                            onChangeRadio={(e) => handleValueChain(e)}
                            className="radio-group-class" // Add any additional classes if necessary
                          />
                          {valueChain == "Yes" && (
                            <div className="form-group row align-items-center mb-0 mt-20">
                              <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                  Find{" "}
                                  {
                                    props.projectSelectFields.find(
                                      (project) =>
                                        project.field_name ===
                                        "Insights and Priorities"
                                    )?.display_name
                                  }
                                  :
                                </label>
                              </div>
                              <div className="col pl-0">
                                <AutoCompleteElement
                                  value={valueChainText}
                                  onChangeValue={(e) =>
                                    setValueChainText(e.value)
                                  }
                                  placeholder="Enter Name"
                                  suggestions={allCompetitorsList.map(
                                    (obj) => obj.competitor_name
                                  )}
                                  completeMethod={getFilteredCompetitors}
                                  className="w-full"
                                  isPurposeScore={true}
                                />
                              </div>
                            </div>
                          )}
                          {valueChain == "No" && (
                            <div className="form-group row align-items-center mb-0 mt-20">
                              <div className="col-md-3 pl-0">
                                <label className="form-label text-left">
                                  Name:
                                </label>
                              </div>
                              <div className="col pl-0">
                                <InputTextElementElement
                                  value={valueChainName}
                                  onChange={(e) => handleValueChainChange(e)}
                                  name="valueChain"
                                  placeholder="Text"
                                  className="w-full"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </Dialog>
                      <Dialog id="videoModal" visible={showVideo}
                        breakpoints={{
                            '1200px': '80vw',    // Larger modal on bigger screens
                            '1024px': '85vw',    // Slightly smaller for medium screens
                            '769': '90vw',     // Responsive on tablets
                            '641px': '95vw',     // Almost full-width on mobile
                        }}
                        modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
                    >
                        <div className="video-overlay">
                            <div className="video-container">
                                <PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="portfolio_purpose" />
                            </div>
                        </div>
                    </Dialog>
                    </div>
                  )}
                  {section.ESG_section_name === "Recommendations" && (
                    <div className="mt-10">
                      <DataTable
                        value={(Object.keys(globalOpportunityData).includes('globalFactors') && globalOpportunityData?.globalFactors.lowest_factors?.length > 0) ? globalOpportunityData.globalFactors?.lowest_factors.slice(0, 3) : []}
                        columns={lowestScoringColumns}
                        isNewField={true}
                      />
                      <DataTable
                        value={(Object.keys(globalOpportunityData).includes('globalFactors') && globalOpportunityData?.globalFactors?.highest_factors?.length > 0) ? globalOpportunityData.globalFactors?.highest_factors.slice(0, 3) : []}
                        columns={highestScoringColumns}
                        isNewField={true}
                      />
                      <DataTable
                        value={(Object.keys(globalOpportunityData).includes('globalFactors') && globalOpportunityData?.globalFactors?.recommendations?.length > 0) ? globalOpportunityData.globalFactors?.recommendations.slice(0, 3) : []}
                        columns={recomendendColumns}
                        isNewField={true}
                      />
                    </div>
                  )}
                </AccordionTab>
              </Accordion>
            </div>
          );
        })}
    </>
  );
});

export default PurposeScore;
